
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const SubAccountService = {

    getSubaccounts: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-sub-account/${account_id}`);
    },

    changeStatusSubaccount: (sub_account_id, status) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/sub-account/change-status`, { sub_account_id, status })
    },

    changeExclusiveSubAccount: (sub_account_id, exclusive) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/sub-account/chage-exclusive`, { sub_account_id, exclusive })
    },

    createSubAccount: (data: {
        account_id: number,
        name: string,
        description: string
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addSubAccount`, data)
    },
}